/**
 * TBD -- For some reason provider isn't passing theme down
 * For now passing generateTheme instead
 */

import * as React from "react";

import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
  ThemeOptions,
} from "@mui/material/styles";
import { generateTheme } from "../helpers";

interface Props {
  children: React.ReactNode;
  customTheme?: ThemeOptions | undefined;
  customBreakpoints?: ThemeOptions | undefined;
}

const Provider = ({
  children,
  customTheme,
  customBreakpoints,
}: Props): JSX.Element => {
  const theme = generateTheme(customTheme, customBreakpoints);
  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export default Provider;
